export const worksData = [
  {
    index: 1,
    title: "MANAJA",
    subtitle: ["React", "TypeScript", "Zustand", "MUI5"],
    details:
      "Get readily available player biodata, team statistics, match reports and player highlights for every game played in a team season ",
    url: "https://manaja.app",
    direction: "left",
    imgBgColor: "#fff",
  },
  {
    index: 2,
    title: "AFRISKAUT",
    subtitle: ["React", "TypeScript", "MUI5", "Zustand"],
    details:
      "Explore detailed statistics, match highlights, and videos of your favorite football player on our platform. Get insights into player performance, goals, assists, and more. Watch exciting match clips and stay updated with the latest performance and updates.",
    url: " https://afriskaut.com",
    direction: "right",
    imgBgColor: "#ffffff",
  },
  // {
  //   index: 3,
  //   title: "VENDGRAM",
  //   subtitle: ["React", "Typescript", "MUI5", "Zustand"],
  //   details:
  //     "Vendgram is building the operating system for African startups. We provide corporate cards, spend management & expense tracking, access to credit, rewards & community.",
  //   url: "https://app.vendgram.co/",
  //   direction: "left",
  //   imgBgColor: "#f7f7f7",
  // },

  {
    index: 3,
    title: "AFRICAN MARKET ENTRY",
    subtitle: ["Nextjs", "TypeScript"],
    details:
      "When it comes to investing in Africa, it's important to understand the jurisdiction of the countries in which you plan to do business.",
    url: "https://www.marketentry.africa/",
    direction: "left",
    imgBgColor: "#fff",
  },
  {
    index: 4,
    title: "RENSA",
    subtitle: ["Nextjs", "Typescript", "ShadCN"],
    details:
      "Your trusted resale marketplace for quick buying and selling of quality items. Rensa simplifies the process of buying and selling household items through convenient auction-style sales, helping users declutter their homes efficiently. More importantly, we help deliver all items for you.",
    url: "https://www.getrensa.com/",
    direction: "right",
    imgBgColor: "#f7f7f7",
  },
  {
    index: 5,
    title: "NIRSAL PORTAL",
    subtitle: ["React", "TypeScript", "Redux", "Ant design"],
    details:
      "NIRSAL AGSMEIS portal for loan application and business plan creation. An initiative for sustainable development and employment generation",
    url: "https://agsmeisapp.nmfb.com.ng",
    direction: "left",
    imgBgColor: "#fff",
  },
  // {
  //   index: 5,
  //   title: "EASZI",
  //   subtitle: ["React", "TypeScript", "Redux", "MUI"],
  //   details:
  //     "Easzi is a multipurpose platform that features an Ecommerce store, a service providing platform, an affiliate reward system, a learning platform and more built on an escrow payment system. ",
  //   url: "https://easzi.com",
  //   direction: "left",
  //   imgBgColor: "#00914f",
  // },

  // {
  //   index: 4,
  //   title: "NEXTJS IP TRACKER ",
  //   subtitle: ["NextJs", "Redux"],
  //   details:
  //     "This is an IP tracker built with NEXTJS. It locates a user's position using ip address when searched",
  //   url: "https://nextjs-iptracker.vercel.app/",
  //   direction: "right",
  //   imgBgColor: "",
  // },

  // {
  //   index: 5,
  //   title: "CONVERTER SENSEI ",
  //   subtitle: ["Javascript", "CSS3", "HTML5"],
  //   details:
  //     "A PWA multipurpose converter app. It can convert between date, units, number base and Roman numerals.",
  //   url: "https://converter-sensei.web.app/calc.html",
  //   direction: "left",
  // },
  // {
  //   index: 6,
  //   title: "LOOPSTUDIOS",
  //   subtitle: ["NextJs"],
  //   details: "A frontend Mentor challenge built with Nextjs.",
  //   url: " https://cadprojects.vercel.app/",
  //   direction: "right",
  // },
];
